import { getAuthToken } from "../context/auth-context";
import { CALL_API } from "../context/constValues";

async function consultar(path, { desde, hasta, tipo }) {
  const params = new URLSearchParams();
  if (desde) params.set("desde", desde);
  if (hasta) params.set("hasta", hasta);
  if (tipo) params.set("tipo", tipo);
  const response = await fetch(`${CALL_API}${path}?${params.toString()}`, {
    headers: { Authorization: `Bearer ${getAuthToken()}` },
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "No se pudo cargar la auditoría");
  return data.data || {};
}

export const getAuditoriaCliente = (id, rango) =>
  consultar(`/auditoria/cliente/${id}`, rango);

export const getAuditoriaCuenta = (id, rango) =>
  consultar(`/auditoria/cuenta/${id}`, rango);

export const getAuditoriaAdministracion = (rango) =>
  consultar("/auditoria/administracion", rango);
